module.exports = __webpack_public_path__ + "static/media/b3.cd2b4b9.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wangxingxing/b3.mp3
// module id = Xrrq
// module chunks = 0